var map = {
	"./PlacesParts.svg": "7ecb",
	"./absence-plans.svg": "63fb",
	"./add-attendance.svg": "6b56",
	"./add-departure.svg": "8836",
	"./add.svg": "24e9",
	"./addUser.svg": "bd85",
	"./address.svg": "597a",
	"./alert.svg": "49bb",
	"./allowances-daily-plans.svg": "7e59",
	"./allowances-plans.svg": "a71c",
	"./allowances.svg": "bbc4",
	"./approve-cancel-reservation.svg": "7a4d",
	"./approve-reservation.svg": "2bcd",
	"./approve-schedule.svg": "4c0f",
	"./attend-reservation.svg": "4e21",
	"./attendance.svg": "b007",
	"./attendanceHistory.svg": "da0b",
	"./balances-plans.svg": "e340",
	"./banks.svg": "75c8",
	"./bg-01.jpg": "33da",
	"./blood-types.svg": "1936",
	"./branches.svg": "bbcf",
	"./buildings.svg": "95db",
	"./cancel-reservation.svg": "4260",
	"./cancel.svg": "541d",
	"./category.svg": "54d0",
	"./chambers.svg": "a1f9",
	"./changePassword.svg": "8d77",
	"./checkmark.svg": "f2fa",
	"./cities.svg": "acd9",
	"./citizenship.svg": "dbb2",
	"./city.svg": "caa0",
	"./client-roles.svg": "b715",
	"./client.svg": "e0e3",
	"./clients.svg": "90ee",
	"./code.svg": "2186",
	"./confirm.svg": "7819",
	"./contractor-roles.svg": "761c",
	"./contractor.svg": "fcc2",
	"./contractors.svg": "1684",
	"./countries.svg": "3a4b",
	"./country.svg": "0901",
	"./date.svg": "9bcd",
	"./dateAndTime.svg": "47fe",
	"./days.svg": "8ef3",
	"./description.svg": "ec2e",
	"./diagnosis.svg": "8c05",
	"./disease.svg": "6282",
	"./district.svg": "7e17",
	"./districts.svg": "8c93",
	"./doctors.svg": "a74f",
	"./drivingLicense.svg": "ccf6",
	"./earth.svg": "cb65",
	"./edit.svg": "b0e3",
	"./email.svg": "7711",
	"./employee-roles.svg": "5fab",
	"./employee-salary-setting.svg": "3345",
	"./employee.svg": "ad39",
	"./employees.svg": "91d3",
	"./enquiry-reservations.svg": "276b",
	"./enter-reservation.svg": "be5d",
	"./establishment-roles.svg": "ca3b",
	"./establishment.svg": "57b6",
	"./expenses-types.svg": "a6bb",
	"./expenses.svg": "9ccb",
	"./eye-hide.svg": "4775",
	"./eye-show.svg": "c159",
	"./family.svg": "7bb6",
	"./filter.svg": "b05f",
	"./finance.svg": "10bd",
	"./finances.svg": "f80f",
	"./finish-reservation.svg": "9471",
	"./floors.svg": "4557",
	"./gender.svg": "8bcb",
	"./general-specialities.svg": "0018",
	"./governate.svg": "f308",
	"./governates.svg": "0404",
	"./guest.svg": "f7f9",
	"./holiday.svg": "22b3",
	"./homepage.svg": "8cf7",
	"./hours.svg": "19bc",
	"./hyperlink.svg": "678d",
	"./illustrator-forgot-password.svg": "7695",
	"./illustrator-login.svg": "2a0f",
	"./illustrator-mission.svg": "8edc",
	"./illustrator-noData.svg": "514c",
	"./illustrator-task.svg": "c515",
	"./illustrator-vision.svg": "e791",
	"./illustrator-work-time.svg": "1590",
	"./illustrator-work.svg": "8078",
	"./info.svg": "db39",
	"./insurance-companies.svg": "da5d",
	"./insurances-plans.svg": "84cb",
	"./insurances.svg": "5f53",
	"./jobs.svg": "e241",
	"./kilometer.svg": "d20a",
	"./kilometer2.svg": "4cf2",
	"./kilometer3.svg": "be8f",
	"./lang-ar.svg": "5b39",
	"./lang-en.svg": "b888",
	"./latitude.svg": "3432",
	"./location.svg": "3589",
	"./logo -shadwo-padel.png": "d3d8",
	"./logo-admins-egypt.png": "f623",
	"./logo.png": "9d64",
	"./logooooooo.png": "b59d",
	"./logout.svg": "4488",
	"./longitude.svg": "5fe3",
	"./main-columns.svg": "2c27",
	"./man.svg": "eb6f",
	"./maritalStatus.svg": "9a34",
	"./maxDiscountPercentage.svg": "b1ae",
	"./media.svg": "0500",
	"./medication-quantity.svg": "da1e",
	"./medicines-types.svg": "1467",
	"./medicines.svg": "6ec8",
	"./merge.svg": "f0dc",
	"./method-paids.svg": "0984",
	"./militaryStatus.svg": "b1d8",
	"./minutes.svg": "59e4",
	"./mode-dark.svg": "be60",
	"./mode-light.svg": "e7c3",
	"./money.svg": "095c",
	"./month-allowances-plans.svg": "1eb2",
	"./months-settings.svg": "0ce7",
	"./movement.svg": "8d1d",
	"./nationalNumber.svg": "1f8b",
	"./news-defult-img.svg": "f16c",
	"./news.svg": "8025",
	"./noInternet.svg": "ea33",
	"./notes.svg": "bf2f",
	"./number.svg": "80e1",
	"./offers.svg": "1541",
	"./office-time.svg": "9d23",
	"./office.svg": "8de2",
	"./official-holidays-plans.svg": "8bef",
	"./overtime-plans.svg": "7fe3",
	"./passportNumber.svg": "f6c8",
	"./passwordlock.svg": "8600",
	"./pay.svg": "46d6",
	"./payment-method.svg": "8423",
	"./payroll.svg": "da48",
	"./pdf.svg": "5fe9",
	"./pencil.svg": "68e3",
	"./percentage.svg": "4be0",
	"./phone-landline.svg": "eef0",
	"./phone.svg": "cf63",
	"./places-media.svg": "78ec",
	"./places-work-plans.svg": "1913",
	"./places-x.svg": "25c6",
	"./places.svg": "ea57",
	"./plus.svg": "5860",
	"./points.svg": "dbc9",
	"./price-offer.svg": "ac89",
	"./privilege.svg": "cc50",
	"./privileges.svg": "d3d9",
	"./qr-code.svg": "e6cf",
	"./qualifications.svg": "0fb7",
	"./reason.svg": "465a",
	"./refund.svg": "9d70",
	"./register.svg": "99e0",
	"./relative-relation.svg": "4a7ba",
	"./report.svg": "3c8a",
	"./reports.svg": "c387",
	"./requirement-types.svg": "d2f5",
	"./requirements.svg": "d4bc",
	"./reservations.svg": "a7ee",
	"./reserve.svg": "5455",
	"./revenues-types.svg": "c14c",
	"./revenues.svg": "1fad",
	"./salary-effects.svg": "881a",
	"./salary-settings.svg": "faec",
	"./scientific-degrees.svg": "1c4b",
	"./search.svg": "22ee",
	"./seconds.svg": "8fbb",
	"./sectors.svg": "7c7d",
	"./services-defalut.svg": "fdc6",
	"./services-payments.svg": "dee9",
	"./services-reservations.svg": "9789",
	"./services-types.svg": "64ca",
	"./services.svg": "0961",
	"./settings-additional.svg": "92b4",
	"./settings-establishment.svg": "7cdb",
	"./settings-general.svg": "437d",
	"./settings-other.svg": "cbba",
	"./settings-salary.svg": "ce6f",
	"./settings.svg": "09a5",
	"./sheets.svg": "ba9c",
	"./sign-in.svg": "0622",
	"./slices.svg": "b5cd",
	"./slider1.jpg": "3f74",
	"./slider2.gif": "528e",
	"./slider3.jpg": "e83e",
	"./slider4.gif": "eb72",
	"./special-spcialities.svg": "e769",
	"./statistics.svg": "2356",
	"./stores.svg": "99c9",
	"./time.svg": "56de",
	"./transaction-points.svg": "cba2",
	"./trash.svg": "311a",
	"./treasuries-transactions.svg": "7740",
	"./treasuries.svg": "0909",
	"./treatments-reservation.svg": "7c732",
	"./type.svg": "bdf5",
	"./user-login.svg": "4f54",
	"./user-profile.png": "5198",
	"./user-roles.svg": "4108",
	"./user.jpg": "3810",
	"./verification-code.svg": "b5ec",
	"./video-camera.svg": "463c",
	"./waiting-back.svg": "bfa1",
	"./work-plan-days.svg": "05be",
	"./work-plans.svg": "ddb4",
	"./work-schedule.svg": "f95f",
	"./work-shifts.svg": "98b4",
	"./year-settings.svg": "9d2a",
	"./year.svg": "5f60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";